<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>
      <p class="txt-tranf txt-center fonsize-20 magb20">
        <b
          >PHỤ LỤC<br />
          BÀN GIAO THIẾT BỊ THANH TOÁN THẺ & CHÍNH SÁCH HOÀN TIỀN MUA THIẾT BỊ
        </b>
      </p>
      <p class="txt-center">
        (PLHTTB:
        <mark>{{ dataAppendix.code }}</mark>
        )
      </p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          <span>
            Hợp đồng hợp tác chấp nhận thanh toán số
            <mark>{{
              dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
            }}</mark>
          </span>
          <p class="magt10">
            (sau đây được viết tắt là “Hợp đồng”) ký ngày
            <mark v-if="dataAppendix?.isNganluongContract">
              {{ dataAppendix?.dateSignContract | formatDate }}</mark
            >
            <mark v-else>
              {{
                dataContract.effectiveFromDTO
                  ? dataContract.effectiveFromDTO
                  : dataContract.dateSign | formatDate
              }}</mark
            >
          </p>
        </li>
        <li>Nhu cầu và khả năng của hai Bên.</li>
      </ol>
      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</mark>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:'
            : 'tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:'
        }}
      </p>
      <p class="flex fonsize-16 txt-tranf">
        <b v-if="!checkCreatedDateNganluong(dataAppendix)"
          >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
        >
        <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p v-if="checkCreatedDateNganluong(dataAppendix)">
        Trụ sở: Tầng 3, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <p v-else>
        Trụ sở: Tầng 12A, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <div class="form form-ext">
        <p>
          Điện thoại: 024 36320986
          <span class="ml-4" v-if="!checkCreatedDateNganluong(dataAppendix)"
            >Fax: 024 36320987</span
          >
        </p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tài khoản: 11001010157634</p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tại: Ngân hàng Maritimebank</p>

        <p v-if="checkCreatedDateNganluong(dataAppendix)">Mã số thuế: 0106001236</p>
        <p v-else>Mã số thuế: 0106393463</p>
        <p>
          Người đại diện:
          <b
            v-if="
              dataAppendix?.dateSignAppendixDTO ||
              dataAppendix?.dateCreatedAppendixDTO ||
              dataContract?.effectiveFromDTO
                ? (dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                : new Date() < new Date('2026-01-07')
            "
            >ĐỖ CÔNG DIỄN</b
          >
          <b v-else>Ông NGUYỄN TIẾN LƯỢNG</b>
          <span class="ml-4"
            >Chức vụ: <b v-if="!checkCreatedDateNganluong(dataAppendix)">Tổng Giám Đốc</b
            ><b v-else>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></span
          >
        </p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">
          Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026
        </p>
        <p>
          NVKD:
          <b>{{
            dataContract.saleInfoRes && dataContract.saleInfoRes.name
              ? dataContract.saleInfoRes.name
              : ''
          }}</b>
          <span class="ml-4">Điện thoại:</span>
          <b>{{
            dataContract.saleInfoRes && dataContract.saleInfoRes.mobile
              ? dataContract.saleInfoRes.mobile
              : ''
          }}</b>
        </p>
      </div>
      <p>và</p>
      <p class="flex fonsize-16 txt-tranf">
        <span class="nowrap"> <b>BÊN B:</b></span>
        <mark>
          <b>{{ customerInfo.merchantName }}</b>
        </mark>
      </p>
      <div class="form form-ext">
        <p>
          <span>Trụ sở: </span>
          <mark>
            {{ customerInfo.address }}, {{ customerInfo.district }},
            {{ customerInfo.city }}
          </mark>
        </p>
        <p>
          Website:<mark v-if="customerInfo.website"> {{ customerInfo.website }}</mark>
        </p>
        <p>
          <span>Điện thoại:</span><mark>{{ customerInfo.mobile }}</mark>
          <span class="ml-4"> Fax: </span>
        </p>
        <p>
          Tài khoản:<mark> {{ customerInfo.accountNo }}</mark>
        </p>
        <p>
          Tại:<mark> {{ customerInfo.bankName }}</mark>
        </p>
        <p>
          <span>Mã số thuế:</span>
          <mark>
            {{ customerInfo.businessRegistrationNumber }}
          </mark>
        </p>
        <p>
          <span>Họ và tên người đại diện: </span
          ><mark
            ><b>{{ customerInfo.customerName }}</b></mark
          >
          <span class="ml-4"
            >Chức vụ: <mark v-if="customerInfo.position"> {{ customerInfo.position }}</mark></span
          >
        </p>
      </div>

      <p>Cùng thỏa thuận hợp tác và cam kết thực hiện những điều sau đây:</p>

      <ol class="form-style1">
        <li>
          <h1>THIẾT BỊ</h1>
          <ol>
            <li>
              <span class="txt-bold"> Thông tin thiết bị </span>
              <ul>
                <li>
                  <p>Danh mục tên thiết bị</p>
                  <div class="table-responsive">
                    <table>
                      <thead>
                        <tr
                          class="bg-head"
                          v-for="(item, index) in deviceMposListHead"
                          :key="index"
                        >
                          <th>
                            <b>{{ item.index }}</b>
                          </th>
                          <th>
                            <b>{{ item.fullName }}</b>
                          </th>
                          <th>
                            <b>{{ item.name }}</b>
                          </th>
                          <th>
                            <b>{{ item.shortName }}</b>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="text-center"
                          v-for="(item, index) in deviceMposListContent"
                          :key="index"
                        >
                          <td>{{ item.index }}</td>
                          <td>{{ item.fullName }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.shortName }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
                <li>
                  <p>
                    Bên B đồng ý mua thiết bị (viết tắt là “TB”) đọc thẻ (Mobile Card Reader) của
                    Bên A, thiết bị sử dụng tốt, đúng nhãn hiệu của hãng sản xuất. Cụ thể như sau:
                  </p>
                  <div class="table-responsive">
                    <table>
                      <thead>
                        <tr class="bg-head">
                          <th><b>Tên thiết bị rút gọn</b></th>
                          <th><b>Số lượng</b></th>
                          <th><b>Đơn Giá (VNĐ)</b></th>
                          <th>
                            <b>Thành tiền (VNĐ, bao gồm VAT) </b>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="txt-center"
                          v-for="(item, index) in appendixCashbackOrDevice"
                          :key="index"
                        >
                          <td>{{ item.displayName }}</td>
                          <td>
                            {{ item.quantity }}
                          </td>
                          <td>
                            {{ item.price | fomatCurrency }}
                          </td>
                          <td>
                            {{ item.totalPrice | fomatCurrency }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p>
                    Bên B phải thực hiện thanh toán cho Bên A tổng giá trị thiết bị theo Phụ lục hợp
                    đồng là:
                    <mark
                      ><b>{{ dataAppendix ? dataAppendix.price : 0 | fomatCurrency }} </b></mark
                    >
                    <i
                      >(Bằng chữ:
                      <mark
                        ><b
                          >{{ dataAppendix ? dataAppendix.price : 0 | formatPriceToText }} đồng</b
                        ></mark
                      >).
                    </i>
                  </p>
                </li>
                <li>
                  <p>Thời hạn và phương thức thanh toán:</p>
                  <ul class="form-style2">
                    <li>Thời hạn thanh toán:<b> ngay</b> sau khi ký Phụ lục hợp đồng này.</li>
                    <li>
                      Hình thức thanh toán: Bên B có thể thanh toán
                      <b>bằng các hình thức sau:</b>
                      <p>
                        <b>Quẹt thẻ trên thiết bị</b> của Bên A do Chuyên viên kinh doanh của Bên A
                        thực hiện (phí quẹt thẻ do Bên A chi trả).
                      </p>
                      <p>Chuyển khoản ngân hàng đến số tài khoản của Bên A, cụ thể như sau:</p>
                      <div class="table-responsive">
                        <table>
                          <tr>
                            <td style="border-top: 1px">Loại tài khoản</td>
                            <td style="border-top: 1px"><b>VND</b></td>
                          </tr>
                          <tr>
                            <td>Tên chủ tài khoản</td>
                            <td><b>Công ty Cổ Phần Công Nghệ Vi Mô</b></td>
                          </tr>
                          <tr>
                            <td>Số tài khoản ngân hàng</td>
                            <td><b>11001010157634</b></td>
                          </tr>
                          <tr>
                            <td>Tại ngân hàng</td>
                            <td><b>TMCP Hàng Hải Việt Nam</b></td>
                          </tr>
                          <tr>
                            <td>Chi nhánh ngân hàng</td>
                            <td><b>Sở GD - PGD Nam Hà Nội</b></td>
                          </tr>
                        </table>
                      </div>
                    </li>
                    <li>
                      Nội dung thanh toán <i>(Mô tả giao dịch)</i>:
                      <b>Số phiếu thu trên My Nextpay</b>
                      <p>
                        <b
                          >(Số phiếu thu này sẽ được gửi thông tin đến Bên B sau khi Hợp đồng được
                          hoàn thiện trên hệ thống của Bên A)</b
                        >
                      </p>
                    </li>
                  </ul>
                </li>
                <li>
                  <p>
                    Bên A đồng ý áp dụng chính sách ưu đãi hoàn tiền mua thiết bị (viết tắt là “TB”)
                    đọc thẻ (Mobile Card Reader) cho bên B khi & chỉ khi doanh thu của mỗi thiết bị
                    mua trong kỳ kinh doanh (*) đạt các mức bên dưới:
                  </p>
                  <ul class="form-style2">
                    <div class="table-responsive">
                      <table>
                        <thead>
                          <tr class="bg-head">
                            <th><b>LOẠI THIẾT BỊ</b></th>
                            <th><b>GIÁ THIẾT BỊ (VNĐ)</b></th>
                            <th><b>THỜI HẠN TỐI ĐA HOÀN TIỀN (THÁNG)</b></th>
                            <th>
                              <b
                                >DOANH SỐ GIAO DỊCH YÊU CẦU TỐI THIỂU/ 01 THIẾT BỊ/01 THÁNG (VNĐ)</b
                              >
                            </th>
                            <th>
                              <b>MỨC HOÀN TIỀN TỐI ĐA/ 01 THIẾT BỊ/ 01 THÁNG (VNĐ)</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="txt-center">
                            <td>Smartpos pro 2-N33</td>
                            <td>3.500.000</td>
                            <td>02</td>
                            <td>50.000.000</td>
                            <td>250.000</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <b>Lưu ý: </b>
                    <ul class="form-style2">
                      <li>Chi phí hoàn tiền mua thiết bị trên đã bao gồm VAT.</li>
                      <li>Thời gian áp dụng hoàn tiền mua thiết bị được tính như sau:</li>
                      <li>
                        Gọi T là tháng thiết bị kích hoạt trên hệ thống mpos.vn thì ngày bắt đầu áp
                        dụng hoàn tiền mua thiết bị là ngày 25 tháng T+1
                      </li>
                      <li>
                        <b><u>Ví dụ:</u></b>
                        <ul class="form-style2">
                          <i
                            ><b
                              >VD1: Thiết bị Smartpos pro 2-N33 kích hoạt TRƯỚC ngày 25 hàng
                              tháng</b
                            >
                            <br />Thiết bị Smartpos pro 2-N33 kích hoạt vào ngày 20/08/2025 thì:
                          </i>
                          <li>Ngày bắt đầu áp dụng hoàn tiền thiết bị là ngày 25/08/2025.</li>
                          <li>
                            Doanh thu của thiết bị/ 01 tháng sẽ tính từ ngày 25/08/2025 đến hết ngày
                            24/09/2025.
                          </li>
                          <li>
                            Thời hạn tối đa hoàn tiền tính từ ngày 25/08/2025 đến hết ngày
                            24/10/2025.
                          </li>
                        </ul>
                        <ul class="form-style2">
                          <i
                            ><b
                              >VD2: Thiết bị Smartpos pro 2-N33 kích hoạt SAU ngày 25 hàng tháng</b
                            >
                            <br />Thiết bị Smartpos pro 2-N33 kích hoạt vào ngày 27/08/2025 thì:
                          </i>
                          <li>Ngày bắt đầu áp dụng hoàn tiền thiết bị là ngày 25/09/2025.</li>
                          <li>
                            Doanh thu của thiết bị/ 01 tháng sẽ tính từ ngày 25/09/2025 đến hết ngày
                            24/11/2025.
                          </li>
                          <li>
                            Thời hạn tối đa hoàn tiền tính từ ngày 25/09/2025 đến hết ngày
                            24/11/2025..
                          </li>
                        </ul>
                      </li>

                      <li>
                        Thời gian kích hoạt thiết bị
                        <b>là ngày tính từ thời điểm thiết bị được gắn trên hệ thống của Bên A.</b>
                      </li>
                      <li>
                        Trong khoảng thời gian hoàn tiền, nếu tháng nào doanh thu/01 thiết bị/tháng
                        của Bên B không đạt điều kiện trên thì bên B sẽ không được Bên A hoàn tiền
                        mua thiết bị tương ứng tháng đó.
                      </li>
                      <li>
                        <b
                          >Nếu doanh thu giao dịch đủ điều kiện, số tiền sẽ được hoàn theo doanh số
                          của thiết bị theo quy định tại điểm b khoản 1.1 điều 1</b
                        >
                      </li>
                      <li>
                        Doanh thu giao dịch <b>chỉ áp dụng</b> cho các
                        <b>giao dịch quẹt thẻ</b> (không bao gồm giao dịch QR, giao dịch thanh toán
                        từ xa, giao dịch dịch vụ..) qua thiết bị trong phụ lục này.
                      </li>
                    </ul>
                  </ul>
                </li>
                <li>
                  Thời hạn đối soát & thanh toán
                  <p>
                    Kỳ kinh doanh: Gọi T là tháng đối soát, kỳ kinh doanh được tính từ ngày 25 tháng
                    T-1 đến ngày 24 tháng T
                  </p>
                  <p>
                    - Trong vòng 02 (hai) ngày làm việc kể từ khi kết thúc kỳ kinh doanh, hệ thống
                    Bên A sẽ tự động cập nhật đối soát về doanh số giao dịch đã phát sinh trên thiết
                    bị của Bên B trên hệ thống mPOS.vn và mức hoàn tiền mua thiết bị tương ứng cần
                    phải trả (nếu có) trong tháng T.
                  </p>
                  <p>
                    Trong vòng 01 (một) ngày làm việc tiếp theo (không tính ngày nghỉ cuối tuần và
                    các ngày nghỉ Lễ, Tết theo quy định) kể từ khi cập nhật đối soát lên hệ thống,
                    bên A sẽ tiến hành thanh toán hoàn tiền thiết bị bằng hình thức chuyển khoản
                    ngân hàng đến số tài khoản đăng ký nhận tiền của bên B với nội dung VIMO TT
                    HTTB, cụ thể như sau:
                  </p>
                  <div class="table-responsive">
                    <table>
                      <tr>
                        <td style="border-top: 1px">Loại tài khoản</td>
                        <td style="border-top: 1px">VND</td>
                      </tr>
                      <tr>
                        <td>Tên chủ tài khoản</td>
                        <td>
                          {{ customerInfo ? customerInfo.holderName : '' }}
                        </td>
                      </tr>
                      <tr>
                        <td>Số tài khoản ngân hàng</td>
                        <td>
                          {{ customerInfo ? customerInfo.accountNo : '' }}
                        </td>
                      </tr>
                      <tr>
                        <td>Tại ngân hàng</td>
                        <td>
                          {{ customerInfo ? customerInfo.bankName : '' }}
                        </td>
                      </tr>
                      <tr>
                        <td>Chi nhánh ngân hàng</td>
                        <td>
                          {{ customerInfo ? customerInfo.branch : '' }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </li>
                <li>
                  Tình trạng thiết bị
                  <p>
                    Bên A bảo đảm cung cấp hàng hoá sử dụng tốt, đúng nhãn hiệu của hãng sản xuất
                    theo như Điều 1 của Phụ lục hợp đồng này, đóng gói theo tiêu chuẩn nhà sản xuất.
                  </p>
                  <p>
                    Sản phẩm được kiểm tra, cài đặt và đảm bảo hoạt động tốt với hệ thống thanh toán
                    thẻ của Bên A trước khi bàn giao cho Bên B.
                  </p>
                </li>
              </ul>
            </li>
            <li>
              <span class="txt-bold">Thời gian và địa điểm bàn giao thiết bị</span>
              <ul>
                <li>
                  Tối đa 02 (hai) ngày làm việc kể từ ngày Phụ lục này được ký kết và Bên A nhận
                  được tiền thanh toán của Bên B, Bên A sẽ tiến hành giao thiết bị thanh toán thẻ
                  cho Bên B tại địa điểm do Bên B quy định.
                </li>
                <li>Phụ lục này là căn cứ để theo dõi bảo hành thiết bị, đổi hoặc trả thiết bị.</li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>BẢO HÀNH THIẾT BỊ</h1>
          <ol>
            <li>Thời hạn bảo hành là 12 tháng kể từ ngày hai bên ký biên bản bàn giao thiết bị</li>
            <li>
              Đối tượng bảo hành:
              <ul class="form-style2">
                <li>Bảo hành đối với các thiết bị thanh toán thẻ.</li>
                <li>Riêng thiết bị Mini Pos - Model N31 bảo hành cả Dock sạc N31.</li>
                <li>Chính sách bảo hành được áp dụng tuỳ theo quy định tại từng thời điểm.</li>
              </ul>
            </li>
            <li>
              <p>
                Điều kiện bảo hành: Dịch vụ bảo hành nêu trên bao gồm cả thiết bị, phụ tùng thay thế
                và công sửa chữa, được thực hiện trên cơ sở các điều kiện sau đây:
              </p>
              <ul class="form-style2">
                <li>
                  Thiết bị, các bộ phận thành phần, các phụ tùng và các linh kiện còn nguyên tem bảo
                  hành của Bên A và được xác nhận là còn nguyên vẹn như khi cung cấp, lắp đặt ban
                  đầu; thiết bị bị lỗi, bị hư hỏng trong điều kiện sử dụng bình thường và không xuất
                  phát từ các thao tác sai hoặc do lỗi của người sử dụng.
                </li>
                <li>
                  Bên A chỉ có trách nhiệm bảo hành hoặc sửa chữa với những thiết bị do Bên A cung
                  cấp.
                </li>
              </ul>
            </li>
            <li>
              <p>Dịch vụ bảo hành không thực hiện trong các trường hợp sau:</p>
              <ul class="form-style2">
                <li>Thiết bị và các bộ phận đã bị cháy do lỗi của người sử dụng.</li>
                <li>Thiết bị không có tem, không có dấu bảo hành.</li>
                <li>
                  Các thiết bị hư hỏng nghiêm trọng do những sai sót và bất cẩn trong quá trình sử
                  dụng và bảo quản hoặc do những nguyên nhân xuất phát từ một bên thứ ba gây ra.
                </li>
                <li>
                  Hậu quả của việc không chấp hành, tuân thủ các điều kiện lắp đặt hoặc các điều
                  kiện đảm bảo môi trường hoặc các điều kiện, quy chế hoạt động, khai thác thiết bị
                  được nêu trong các tài liệu cung cấp cùng các thiết bị.
                </li>
                <li>
                  Thiết bị được cài đặt, lắp đặt hoặc thay đổi các phụ tùng, phụ kiện, linh kiện
                  liên quan không đúng theo yêu cầu kỹ thuật trong tài liệu cung cấp.
                </li>
                <li>
                  Thiết bị đã bị tô vẽ, sơn, khắc…dẫn đến thay đổi hoặc bị biến dạng hình thức bên
                  ngoài.
                </li>
                <li>
                  Hệ thống cấp điện cho thiết bị được thiết lập, sửa chữa, thay đổi hoặc thay thế
                  không đúng với các điều kiện lắp đặt ban đầu hoặc các điều kiện đảm bảo môi
                  trường, các điều kiện, quy chế hoạt động, khai thác thiết bị được nêu trong tài
                  liệu được cung cấp cùng thiết bị.
                </li>
              </ul>
            </li>
            <li>
              <p>Thực hiện bảo hành</p>
              <ul class="form-style2">
                <li>
                  Sản phẩm cần bảo hành được Bên B gửi lại Bên A để sửa chữa hoặc đổi mới, thời gian
                  chuyển hàng và nhận hàng bảo hành là từ <b>03</b> (ba) <b>đến 05</b> (năm)
                  <b>tuần</b>.
                </li>
                <li>
                  Chi phí chuyển hàng do <b>Bên B</b> thanh toán theo chi phí thực tế phát sinh và
                  được Bên A thông báo trước.
                </li>
              </ul>
            </li>
            <li>
              <p>Địa điểm nhận sản phẩm bảo hành:</p>
              <ul class="form-style2">
                <li>
                  Tại <b>Hà Nội</b>: Tầng 12A, tòa nhà VTC online, số 18 Tam Trinh, Phường Tương
                  Mai. Điện thoại: 0902 144 933.
                </li>
                <li>
                  Tại <b>TP. HCM</b>: Số 240 Nguyễn Đình Chính, Phường Phú Nhuận, TP Hồ Chí Minh.
                  Điện thoại: 0938 989 266.
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>QUY ĐỊNH VỀ THU HỒI VÀ KHOÁ THIẾT BỊ TRÊN HỆ THỐNG</h1>
          <p>Bên A giữ quyền khóa thiết bị trên hệ thống trong các trường hợp sau:</p>
          <ul>
            <li>Bên B vi phạm các điều khoản trong Hợp đồng cung cấp dịch vụ đã ký với Bên A.</li>
            <li>Bên B có thông báo cho Bên A bằng văn bản về việc yêu cầu ngưng sử dụng.</li>
          </ul>
        </li>
        <li>
          <h1>THÔNG TIN THIẾT BỊ BÀN GIAO</h1>
          <p>
            Số lượng thiết bị bàn giao:
            <mark>{{ dataAppendix.numDevices || 0 }}</mark>
            (chiếc). Thông tin chi tiết như sau:
          </p>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th style="width: 100px"><b>Số TT</b></th>
                  <th><b>Serial thiết bị</b></th>
                  <th><b>Loại thiết bị</b></th>
                  <th><b>Địa chỉ đặt thiết bị</b></th>
                  <th><b>Số lượng (chiếc) </b></th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in appendixCashbackOrDevice" :key="index">
                <tr class="txt-center">
                  <td class="txt-center">{{ index + 1 }}</td>
                  <td>{{ item.serialNumber }}</td>
                  <td>
                    <span>
                      {{ item.displayName }}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{ merchantBusinessAreasDevice[index].areaAddress }}
                      <!-- <span v-show="merchantBusinessAreasDevice[index].areaDistrict"> - {{ merchantBusinessAreasDevice[index].areaDistrict }}</span> -->
                      <!-- <span v-show="merchantBusinessAreasDevice[index].areaCity"> - {{ merchantBusinessAreasDevice[index].areaCity }}</span> -->
                    </span>
                  </td>
                  <td>{{ item.quantity }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>TÌNH TRẠNG THIẾT BỊ BÀN GIAO</h1>
          <p>
            Tất cả các thiết bị bàn giao đã được hai bên kiểm tra là sản phẩm mới và sử dụng tốt.
          </p>
        </li>
        <li>
          <h1>NỘI DUNG BÀN GIAO VÀ NGHIỆM THU KHÁC</h1>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th><b>STT</b></th>
                  <th><b>NHÓM DỊCH VỤ</b></th>
                  <th><b>NỘI DUNG HƯỚNG DẪN/ BÀN GIAO</b></th>
                  <th><b>XÁC NHẬN </b></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="txt-center"><b>1</b></td>
                  <td><b>Khởi động thiết bị</b></td>
                  <td>Thao tác bật/ tắt và sạc pin cho thiết bị mới</td>
                  <td rowspan="2">
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>2</b></td>
                  <td rowspan="2">
                    <b>Thanh toán thẻ</b>
                  </td>
                  <td>Nhận diện Thẻ chíp/Thẻ từ/Thẻ Contactless; ATM/Debit/Credit</td>
                  <!-- <td>
                    <span style="font-size: 30px; color: #0085ff"
                      ><i class="bx bx-check"></i
                    ></span>
                  </td> -->
                </tr>
                <tr>
                  <td class="txt-center"><b>3</b></td>
                  <td>
                    Quẹt với thẻ từ / Cắm với thẻ chíp/ Chạm với thẻ Contactless/ In hoá đơn với
                    SmartPOS (nếu có giấy)
                  </td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>

                <tr class="bg-head">
                  <td colspan="4">
                    <b>Thanh toán thông thường/ Trả Góp 0%</b>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>1</b></td>
                  <td rowspan="2"><b>Thao tác sử dụng</b></td>
                  <td>Lựa chọn đúng mục thanh toán thường/ trả góp</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>2</b></td>
                  <td>Lựa chọn ngân hàng và kỳ hạn</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>3</b></td>
                  <td rowspan="3"><b>Quy trình hoàn thiện</b></td>
                  <td>Nhập thông tin hóa đơn và khách hàng (chủ thẻ)</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>4</b></td>
                  <td>Theo từng quy trình của từng NH</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>5</b></td>
                  <td>Các lưu ý "Maritimebank, Techcombank …"</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>6</b></td>
                  <td><b>Tài liệu hướng dẫn</b></td>
                  <td>Thông tin liên hệ các bộ phận Vận hành, Kỹ thuật</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>7</b></td>
                  <td><b>Các khoản phí</b></td>
                  <td>Phí trả góp, phí quẹt thẻ</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>

                <tr class="bg-head">
                  <td colspan="4">
                    <b>Kiểm tra lịch sử giao dịch / Kết toán</b>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>1</b></td>
                  <td rowspan="5"><b>Xác nhận giao dịch</b></td>
                  <td>Lịch sử giao dịch trong ngày/ trước đó</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>2</b></td>
                  <td>Kết toán giao dịch</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>

                <tr>
                  <td class="txt-center"><b>3</b></td>
                  <td>Huỷ giao dịch/ Hoàn tiền giao dịch</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>4</b></td>
                  <td>Gửi lại hoá đơn qua email</td>
                  <td rowspan="2">
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>5</b></td>
                  <td>Đăng nhập bằng email của Merchant trên Website của bên A</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>ĐIỀU KHOẢN THI HÀNH</h1>
          <ul class="form-style2">
            <li>
              Phụ lục này là bộ phận không thể tách rời của Hợp đồng và các điều khoản khác của Hợp
              đồng vẫn được giữ nguyên. Các bên cam kết tuân thủ các quy định trong phụ lục Hợp đồng
              này.
            </li>
            <li>
              Phụ lục này có hiệu lực kể từ ngày đại diện có thẩm quyền của hai Bên tham gia ký kết.
              Thời hạn hiệu lực của Phụ lục này được xác định theo thời hạn hiệu lực của Hợp đồng
              nêu trên trừ khi hai bên có thỏa thuận khác bằng văn bản.
            </li>
            <li>
              Phụ lục này được lập thành 02 (hai) bản có nội dung và giá trị pháp lý như nhau, mỗi
              Bên giữ 01 (một) bản.
            </li>
          </ul>
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {
        deviceMposListHead: [],
        deviceMposListContent: [],
      }
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return (
          this.appendix ?? this.dataContract.lstAppendixDevices.find(e => e.isCreatedWithContract)
        )
      },

      appendixCashbackOrDevice() {
        const appendix = this.dataAppendix
        const devices = appendix.appendixCashback ?? appendix.appendixDevice
        return devices?.deviceInfos ?? []
      },
      merchantBusinessAreasDevice() {
        return this.appendixCashbackOrDevice.map(s => {
          return (
            this.dataAppendix.merchantBusinessAreas.find(z => z.serials.includes(s.serialNumber)) ??
            {}
          )
        })
      },
    },
    mounted() {
      this.deviceMposListHead = this.dataContract.deviceMposList
        ? this.dataContract.deviceMposList.filter((e, i) => i === 0)
        : []
      this.deviceMposListContent = this.dataContract.deviceMposList
        ? this.dataContract.deviceMposList.filter((e, i) => i !== 0)
        : []
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
